exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tour-form[data-v-a90cdd5a]{display:grid\n}\n@media (min-width:900px){\n.tour-form[data-v-a90cdd5a]{grid-gap:40px;grid-template-columns:2fr 1fr\n}\n}\n.tour-form__secondary[data-v-a90cdd5a]{border:1px solid #d5dde2;margin-top:29px;padding:20px\n}\nhr[data-v-a90cdd5a]{margin:60px 0\n}", ""]);

// exports
